var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { DropdownEmbeddableList } from "./DropdownEmbeddableList";
import { DropdownEmbeddableController } from "./DropdownEmbeddableController";
import { DropdownEmbeddableSelectNative } from "./DropdownEmbeddableSelectNative";
let DropdownEmbeddable = class DropdownEmbeddable extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChangeCallback = this.props.onChangeCallback;
        this.controller = new DropdownEmbeddableController({
            id: props.id,
            data: props.options,
            onChangeCallback: props.onChangeCallback,
        });
        this.isDesktop = props.isDesktop;
    }
    componentDidMount() {
        this.controller.activate();
    }
    componentWillUnmount() {
        this.controller.deactivate();
    }
    render() {
        return this.isDesktop
            ?
                React.createElement("div", { id: this.props.id, className: "rj-dropdown-embeddable", onClick: this.controller.showListHandler, "data-uat": `${this.props.dataUat}` },
                    React.createElement("div", { className: "rj-dropdown-embeddable__value", "data-uat": `${this.props.dataUat}-value` }, this.controller.selected.label),
                    React.createElement("div", { className: `rj-dropdown-embeddable__icon rj-dropdown-embeddable__icon--${this.controller.isOpen ? "down" : "up"}`, onClick: this.controller.showListHandler }),
                    this.controller.isOpen &&
                        React.createElement(DropdownEmbeddableList, { dataUat: this.props.dataUat, makeChoice: this.controller.makeChoice, hideListHandler: this.controller.hideListHandler, selected: this.controller.selected, options: this.props.options }))
            :
                React.createElement(DropdownEmbeddableSelectNative, { id: this.props.id, dataUat: this.props.dataUat, makeChoice: this.controller.makeChoiceNative, isOpen: this.controller.isOpen, showListHandler: this.controller.showListHandler, hideListHandler: this.controller.hideListHandler, selected: this.controller.selected, clickHandler: this.controller.clickHandler, options: this.props.options });
    }
};
DropdownEmbeddable = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DropdownEmbeddable);
export { DropdownEmbeddable };
//# sourceMappingURL=DropdownEmbeddable.js.map